var map = {
	"./ELEMENTS.png": 466,
	"./Frame 136 (1).png": 331,
	"./Frame 136.png": 300,
	"./Frame 137 (1).png": 33,
	"./Frame 137.png": 115,
	"./Frame 146.png": 795,
	"./Group 4.png": 214,
	"./Group3.png": 969,
	"./Main - Horizontal Color.png": 140,
	"./NR.png": 991,
	"./Vector.png": 569,
	"./bg-fire 1.png": 915,
	"./лого-Skott-Smeat.png": 995,
	"./лого-Апетитна.png": 135,
	"./лого-курка-по-домашньому.png": 885
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 235;